import { unstable_cache } from "next/cache";
import { ApiFilterResponse } from "@interfaces/filter.types";
import { CACHE_REVALIDATION, CACHE_TAGS } from "@constants/cacheConfig";

const baseURL = process.env.NEXT_PUBLIC_ACKO_DRIVE_CATALOG_SERVICE;

const fetchFiltersFromAPI = async (
  collectionSlug?: string
): Promise<ApiFilterResponse | null> => {
  try {
    const queryParams = new URLSearchParams();

    if (collectionSlug) {
      const decodedSlug = decodeURIComponent(collectionSlug);
      queryParams.append("slug", decodedSlug);
    }

    const apiUrl = `${baseURL}/v1/filters/?${queryParams.toString()}`;
    console.log(`[Filter Service] 🔥 ACTUAL API CALL to ${apiUrl}`);

    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`API returned status ${response.status}`);
    }

    const data = await response.json();
    console.log(`[Filter Service] ✅ API call successful, data cached for ${CACHE_REVALIDATION.FILTER_DATA}s (1 day)`);

    return data;
  } catch (error) {
    console.error("[Filter Service] ❌ Error fetching filter options:", error);
    return null;
  }
};

const getCachedFilters = unstable_cache(
  async (collectionSlug?: string) => {
    return fetchFiltersFromAPI(collectionSlug);
  },
  ["filter-data"],
  {
    revalidate: CACHE_REVALIDATION.FILTER_DATA,
    tags: [CACHE_TAGS.FILTER_DATA],
  }
);

export const filterService = {
  getFilters: async (collectionSlug?: string) => {
    console.log('[Filter Service] 📞 getFilters() called - checking cache...');
    return getCachedFilters(collectionSlug);
  },
};
